var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 15.7188L23.9375 11.5H21.25C20.8125 11.5 20.5 11.1875 20.5 10.75C20.5 10.3438 20.8125 10 21.25 10H25.7188C26.1562 10 26.4688 10.3438 26.4688 10.75V15.25C26.4688 15.6875 26.1562 16 25.7188 16C25.3125 16 24.9688 15.6875 24.9688 15.25V12.5625L20.75 16.7812C20.4688 17.0938 20 17.0938 19.7188 16.7812C19.4062 16.5 19.4062 16.0312 19.7188 15.7188ZM17.2812 20.2812L13.0312 24.5H15.75C16.1562 24.5 16.5 24.8438 16.5 25.25C16.5 25.6875 16.1562 26 15.75 26H11.25C10.8125 26 10.5 25.6875 10.5 25.25V20.75C10.5 20.3438 10.8125 20 11.25 20C11.6562 20 12 20.3438 12 20.75V23.4688L16.2188 19.25C16.5 18.9375 16.9688 18.9375 17.2812 19.25C17.5625 19.5312 17.5625 20 17.2812 20.2812Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandGray);
export default __webpack_public_path__ + "static/media/expand-gray.9e98544b908cd006448e014025509d25.svg";
export { ForwardRef as ReactComponent };